<template>
  <div>
    <vue-data-table
      :headers="headers"
      :data="sellerSales"
      :buttons="buttons"
      :items-per-page="10"
      :filter-fields="filterFields"
      :filter-data="filter"
      :tableActions="tableActions"
      filter-title="Filtrer les ventes vendeurs"
      @filter="toFilter"
      @reset="resetFilter"
    >
    </vue-data-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

const defaultFilter = () => ({
  startDate: "",
  endDate: "",
  seller_reference: "",
  seller_customer_reference: "",
});

export default {
  data() {
    return {
      filter: defaultFilter(),
      tableActions: [
        {
          title: "Actualiser",
          icon: "bi bi-arrow-clockwise",
          class: "btn btn-secondary",
          action: () => this.refresh(),
        },
        {
          title: "Créer une nouvelle vente vendeur",
          icon: "bi bi-plus-square",
          class: "btn btn-primary",
          action: () => this.$router.push({ name: "seller-sales-create" }),
        },
      ],
      headers: [
        { label: "Référence", field: "reference", class: "text-center" },
        {
          label: "Client Vendeur",
          field: "customerFullName",
          class: "text-left",
        },
        {
          label: "Vendeur",
          field: "sellerFullName",
          class: "text-left",
        },
        { label: "Date", field: "date", class: "text-center" },
        { label: "Total TTC", field: "totalPriceTTC", class: "text-right" },

        {
          label: "Quantité Totale",
          field: "totalQuantity",
          class: "text-right",
        },
        { label: "Montant Payé", field: "amountPaid", class: "text-right" },
        { label: "Montant Impayé", field: "amountUnpaid", class: "text-right" },
        { label: "Échéance", field: "deadline", class: "text-center" },
      ],
      buttons: [
        {
          label: "Détails",
          icon: "bi bi-eye",
          class: "btn-info",
          action: (row) =>
            this.$router.push({
              name: "seller-sales-details",
              params: { reference: row.reference },
            }),
        },
        {
          label: "Edit",
          icon: "bi bi-pencil",
          class: "btn-primary",
          action: (row) =>
            this.$router.push({
              name: "seller-sales-edit",
              params: { reference: row.reference },
            }),
        },
        {
          label: "Delete",
          icon: "bi bi-trash",
          class: "btn-danger",
          action: (row) => this.remove(row.reference),
        },
      ],
    };
  },
  computed: {
    ...mapGetters("sellerSale", {
      sellerSales: "getSellerSales",
    }),
    ...mapGetters("seller", {
      sellers: "getAll",
    }),
    ...mapGetters("sellerCustomer", {
      sellerCustomers: "getAll",
    }),
    filterFields() {
      return [
        {
          type: "select",
          label: "Vendeur",
          model: "seller_reference",
          options: this.sellers || [],
          labelColumn: "fullName",
          valueColumn: "reference",
        },
        {
          type: "select",
          label: "Client vendeur",
          model: "seller_customer_reference",
          options: this.sellerCustomers || [],
          labelColumn: "fullName",
          valueColumn: "reference",
        },
      ];
    },
  },
  mounted() {
    this.refresh();
  },
  methods: {
    async remove(reference) {
      await this.$store.dispatch("sellerSale/destroy", reference);
    },
    async refresh() {
      await Promise.all([
        this.$store.dispatch("sellerSale/getAll"),
        this.$store.dispatch("seller/getAll"),
        this.$store.dispatch("sellerCustomer/getAll"),
      ]);
    },
    async toFilter(rawValues) {
      const sanitized = this.sanitizeFilter(rawValues);
      this.filter = { ...sanitized };

      const payload = this.buildFilterPayload(sanitized);

      if (this.isFilterEmpty(payload)) {
        await this.refresh();
        return;
      }

      await this.$store.dispatch("sellerSale/filter", payload);
    },
    async resetFilter() {
      this.filter = defaultFilter();
      await this.refresh();
    },
    sanitizeFilter(filterValues = {}) {
      const normalized = defaultFilter();
      Object.keys(normalized).forEach((key) => {
        if (Object.prototype.hasOwnProperty.call(filterValues, key)) {
          normalized[key] =
            filterValues[key] === null || filterValues[key] === undefined
              ? ""
              : filterValues[key];
        }
      });
      return normalized;
    },
    buildFilterPayload(filterValues = {}) {
      return {
        startDate: filterValues.startDate || null,
        endDate: filterValues.endDate || null,
        seller_reference: filterValues.seller_reference || null,
        seller_customer_reference:
          filterValues.seller_customer_reference || null,
      };
    },
    isFilterEmpty(payload = {}) {
      return (
        !payload.startDate &&
        !payload.endDate &&
        !payload.seller_reference &&
        !payload.seller_customer_reference
      );
    },
  },
};
</script>
